import { render } from "./B2bTableSalesReport.vue?vue&type=template&id=4182eff8&scoped=true&lang=pug"
import script from "./B2bTableSalesReport.vue?vue&type=script&lang=js"
export * from "./B2bTableSalesReport.vue?vue&type=script&lang=js"

import "./B2bTableSalesReport.vue?vue&type=style&index=0&id=4182eff8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4182eff8"]])

export default __exports__